<template>
  <StyledWinButton
    :class="$attrs.class"
    :href="url"
    :meta="meta"
    :odds="odds"
    :disabled="disabled"
    :buttonId="buttonId"
    :name="name"
    :suspended="suspended"
    :winnings="localisedWinnings"
  />
</template>

<script lang="ts">
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { PropType, defineComponent, computed } from "vue";
import { Option } from "@fresh8/types/src/betData";
import StyledWinButton from "./styled/WinButton.vue";
import { formatOdds } from "@fresh8/ad-data-composition/src/lib/formatOdds";
import usePotentialWinnings from "@fresh8/ad-data-composition/src/usePotentialWinnings";
import { getTranslation } from "@fresh8/ad-data-composition/src/lang";
import {
  injectTemplateSize,
  SKYSCRAPER
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import { oddsTypeEnum } from "@fresh8/types/src";

export default defineComponent({
  name: "WinButton",
  components: {
    StyledWinButton
  },
  props: {
    option: { type: Object as PropType<Option>, required: true },
    isDraw: { type: Boolean, required: false, default: false }
  },
  setup(props) {
    const { adTemplate, buttons } = injectBrand() || ({} as BrandContext);
    const buttonId = computed(
      () =>
        adTemplate.value?.market?.oddsButton ||
        (buttons.value && Object.keys(buttons.value)[0]) ||
        ""
    );
    const layout = injectTemplateSize();

    const odds = computed(
      () =>
        (props.option &&
          formatOdds(
            props.option.odds,
            adTemplate.value?.market.oddsButtonTemplate ||
              oddsTypeEnum.FRACTIONAL_ODDS
          )) ||
        "-"
    );

    const { localisedWinnings } = usePotentialWinnings(props.option.odds);
    const name = computed(() => {
      if (props.isDraw) {
        return getTranslation(window.navigator.language.toLowerCase())
          .ButtonTexts.Draw;
      }
      if (layout?.size.value.name === SKYSCRAPER.name) {
        return props.option?.name.micro;
      }
      return props.option?.name.short;
    });

    return {
      odds,
      localisedWinnings,
      name,
      meta: props.option?.meta,
      url: props.option?.betslipUrl,
      disabled: !props.option || props.option?.suspended,
      buttonId,
      suspended: props.option?.suspended
    };
  }
});
</script>

<style></style>
